import React from 'react';

import type { IconSidebarMenu } from 'commons/modules/SidebarMenu/icon-sidebar-menu';
import type { SidebarMenuConfig } from 'commons/modules/SidebarMenu/item-sidebar-menu';

import { MENU_KEYS, SCREENS_KEYS } from 'constants/constants';

import ClientsIcon from '../assets/ClientsIcon';
import FundsIcon from '../assets/FundsIcon';
import PortfoliosIcon from '../assets/PortfoliosIcon';
import RebalanceFundsIcon from '../assets/RebalanceFundsIcon';
import ReportsIcon from '../assets/ReportsIcon';
import AdministrationIcon from '../assets/AdministrationIcon';

export const itemsMenu: SidebarMenuConfig[] = [
  {
    title: 'Clientes',
    menuKey: MENU_KEYS.clients,
    // eslint-disable-next-line react/display-name
    icon: (props: IconSidebarMenu) => <ClientsIcon {...props} />,
    options: [
      {
        title: 'Administraci\u00F3n',
        nav: '/clientes',
        screenKey: SCREENS_KEYS.administration,
      },
      {
        title: 'Posiciones',
        screenKey: SCREENS_KEYS.positions,
        nav: '/clientes/0/posiciones-en-el-portafolio',
      },
      {
        title: 'Nuevo Cliente',
        screenKey: SCREENS_KEYS.newClient,
        nav: '/clientes/onboarding',
      },
      {
        title: 'Carga masiva',
        screenKey: SCREENS_KEYS.massUpload,
        nav: '/clientes/carga-masiva',
      },
    ],
  },
  {
    title: 'Fondos',
    menuKey: MENU_KEYS.funds,
    // eslint-disable-next-line react/display-name
    icon: (props: IconSidebarMenu) => <FundsIcon {...props} />,
    options: [
      {
        title: 'Administraci\u00F3n',
        nav: '/fondos',
        screenKey: SCREENS_KEYS.fundsAdministration,
      },
      {
        title: 'Posiciones',
        screenKey: SCREENS_KEYS.fundsPositions,
        nav: '/fondos/0/posiciones-en-el-portafolio',
      },
    ],
  },
  {
    title: 'Portafolios y Rebalanceo',
    menuKey: MENU_KEYS.portfolioRebalance,
    // eslint-disable-next-line react/display-name
    icon: (props: IconSidebarMenu) => <PortfoliosIcon {...props} />,
    options: [
      {
        title: 'Portafolios',
        screenKey: SCREENS_KEYS.portfolio,
        nav: '/portafolio-modelo/portafolios',
      },
      {
        title: 'Estrategia',
        screenKey: SCREENS_KEYS.strategy,
        nav: '/portafolio-modelo/estrategia',
      },
      {
        title: 'Restricciones',
        screenKey: SCREENS_KEYS.restrictions,
        nav: '/portafolio-modelo/restricciones',
      },
      {
        title: 'Rebalanceo',
        screenKey: SCREENS_KEYS.balancing,
        nav: '/portafolio-modelo/rebalanceo',
      },
    ],
  },
  {
    title: 'Rebalanceo Fondos',
    menuKey: MENU_KEYS.rebalanceFunds,
    // eslint-disable-next-line react/display-name
    icon: (props: IconSidebarMenu) => <RebalanceFundsIcon {...props} />,
    options: [
      {
        title: 'Portafolios',
        screenKey: SCREENS_KEYS.fundsPortfolio,
        nav: '/portafolio-fondos/portafolios',
      },
      {
        title: 'Estrategia',
        screenKey: SCREENS_KEYS.strategy,
        nav: '/portafolio-fondos/estrategia',
      },
      {
        title: 'Restricciones',
        screenKey: SCREENS_KEYS.fundsRestrictions,
        nav: '/portafolio-fondos/restricciones',
      },
      {
        title: 'Rebalanceo',
        screenKey: SCREENS_KEYS.fundsBalancing,
        nav: '/portafolio-fondos/rebalanceo',
      },
    ],
  },
  {
    title: 'Reportes',
    menuKey: MENU_KEYS.reports,
    // eslint-disable-next-line react/display-name
    icon: (props: IconSidebarMenu) => <ReportsIcon {...props} />,
    options: [
      {
        title: 'Operativo',
        screenKey: SCREENS_KEYS.operationReports,
        nav: '/portafolio-modelo/reportes-operacion',
      },
      {
        title: 'Inversi\u00F3n',
        screenKey: SCREENS_KEYS.investment,
        nav: '/portafolio-modelo/inversion',
      },
      {
        title: 'Honorarios',
        screenKey: SCREENS_KEYS.fee,
        nav: '/portafolio-modelo/honorarios',
      },
      {
        title: 'Documental',
        screenKey: SCREENS_KEYS.documentary,
        nav: '/portafolio-modelo/documental',
      },
      {
        title: 'Fondos',
        screenKey: SCREENS_KEYS.reportsFounds,
        nav: '/portafolio-modelo/fondos',
      },
      {
        title: 'Liquidez',
        screenKey: SCREENS_KEYS.liquidityReport,
        nav: '/portafolio-modelo/reporte-liquidez',
      },
    ],
  },
  {
    title: 'Administraci\u00F3n / Gesti\u00F3n',
    menuKey: MENU_KEYS.administrationManagement,
    // eslint-disable-next-line react/display-name
    icon: (props: IconSidebarMenu) => <AdministrationIcon {...props} />,
    options: [
      {
        title: 'Cumplimiento',
        screenKey: SCREENS_KEYS.compliance,
        nav: '/cumplimiento/operaciones',
      },
      {
        title: 'Operación',
        screenKey: SCREENS_KEYS.operation,
        nav: '/archivos/operacion',
      },
      {
        title: 'Configuraci\u00F3n',
        screenKey: SCREENS_KEYS.configuration,
        nav: '/configuracion',
      },
    ],
  },
];
